import React from 'react';
import styled from 'styled-components';
import { Box, BoxProps } from '../../../../next-components/box';
import Avatar from '../../../Avatar';
import { Tooltip, TooltipProps } from '../../../tooltip';
import { FabBouncer } from '../FabBouncer';

/**
 * TODO - Add typings on Avatar package once we convert it to TypeScript
 */
type AvatarProps = {
  src: string;
  alt?: string;
  containerProps?: BoxProps;
  imageProps?: BoxProps;
} & BoxProps;
export type TooltipBouncerProps = BoxProps & {
  avatar: AvatarProps;
  tooltip: Omit<TooltipProps, 'children'>;
};
export const TooltipBouncer = ({
  avatar: {
    src,
    alt,
    ...avatarProps
  },
  tooltip: {
    text,
    show = true,
    ...tooltipRest
  },
  ...rest
}: TooltipBouncerProps) => <FabBouncer display="flex" px="8px" justifyContent="flex-end" right={0} {...rest} data-sentry-element="FabBouncer" data-sentry-component="TooltipBouncer" data-sentry-source-file="TooltipBouncer.tsx">
    <StyledBox data-sentry-element="StyledBox" data-sentry-source-file="TooltipBouncer.tsx">
      <Tooltip text={text} placement="left" backgroundColor="#727272" color="white" tooltipColor="#727272" fontWeight="700" top="15%" py="8px" px="4px" marginLeft="-5px" width="130px" boxShadow="0 4px 10px 0 rgba(86, 86, 86, 0.56)" fontSize="16px" show={show} {...tooltipRest} data-sentry-element="Tooltip" data-sentry-source-file="TooltipBouncer.tsx">
        <Avatar src={src} bg="transparent" containerProps={{
        border: '2px solid #3C5180',
        cursor: 'pointer',
        borderRadius: '50%',
        boxShadow: '0 4px 10px 0 rgba(86, 86, 86, 0.56)',
        overflow: 'unset',
        ...(avatarProps && avatarProps.containerProps)
      }} imageProps={{
        alt
      }} width="88px" height="88px" {...avatarProps} data-sentry-element="Avatar" data-sentry-source-file="TooltipBouncer.tsx" />
      </Tooltip>
    </StyledBox>
  </FabBouncer>;
const StyledBox = styled(Box)`
  transition: all .2s ease-in-out;
  &:hover {
    transform: scale(1.1);
    cursor: pointer;
  }
  * {
    &:hover {
      cursor: pointer;
    }
  }
`;